class Stripe {
  constructor({ account, url }) {
    this.account = account;
    this.url = url;
  }
}

export default Stripe;
